import { parseHtml } from './parse-html';
import { removeNonAscii } from './remove-non-ascii';

export const skills_patterns = {
	'node.js': ['.*node.*'],
	'react native': ['.*react.?native.*'],
	'.net': ['.*.net.*'],
	'flask': ['.*flask.*'],
	'django': ['.*django.*'],
	'php': ['.*php.*'],
	'laravel': ['.*laravel.*'],
	'ruby': ['.*ruby.*'],
	'rails': ['.*rails.*'],
	'sql': ['.*sql.*', '.*my.*sql.*', '.*postgresql.*'],
	'css': ['.*css.*'],
	'react': ['.*react.*j?s?'],
	'angular': ['.*angul.?r.*'],
	'vue': ['.*vue.*'],
	'jquery': ['.*j.?qu.?ry.*'],
	'ajax': ['.*ajax.*'],
	'flutter': ['.*flutter.*'],
	'kotlin': ['.*kotlin.*'],
	'swift': ['.*swift.*'],
	'docker': ['.*docker.*'],
	'javascript': ['javascript', 'es6'],
	'python': ['python'],
	'wordpress': ['wordpress'],
	'objectivec': ['objective.?c'],
	'bash': ['.*bash.*'],
	'testing': ['testing'],
	'android': ['android'],
	'rest': ['rest.*'],
	'ios': ['ios'],
	'devops': ['devops'],
	'c#': ['c#'],
	'kubernetes': ['kubernetes'],
	'html': ['html.*'],
	'agile': ['agile'],
	'aws': ['aws'],
	'wireframing': ['wireframing'],
	'automation': ['automation'],
	'express': ['.*express.*'],
	'scala': ['scala'],
	'linux': ['linux'],
	'typescript': ['type.?script'],
	'spring': ['spring'],
	'redux': ['redux.*'],
	'selenium': ['selenium'],
	'oop': ['oop', 'object.?oriented.?'],
	'websocket': ['websocket', 'socket.?i?o?'],
	'postman': ['postman'],
	'spark': ['spark'],
	'magneto': ['magneto'],
	'scrum': ['scrum'],
	'azure': ['azure'],
	'codeigniter': ['codeigniter'],
	'nest.js': ['nest.*'],
	'mongo': ['mongo.*'],
	'graphql': ['graph.*ql'],
	'kafka': ['kafka'],
	'sass': ['sass'],
	'rdbms': ['rdbms'],
	'soab': ['soap.*'],
	'hibernate': ['hibernate'],
	'git': ['git'],
	'jenkins': ['jenkins'],
	'mvvm': ['mvvm'],
	'katalon': ['katalon'],
	'api': ['.*api.*'],
	'c': ['^c$'],
	'warehous': ['.*warehous.*'],
	'responsive': ['responsive.*'],
	'swagger': ['swagger'],
	'postgraphile': ['postgraphile'],
	'ansible': ['ansible'],
	'photoshop': ['.*photoshop'],
	'jira': ['jira'],
	'data structures': ['data structure.?'],
	'machine learning': ['machine learning'],
	'algorithms': ['algorithms?'],
	'oracle': ['oracle'],
	'design patterns': ['design patterns?'],
	'data analysis': ['data analysis'],
	'matlab': ['matlab'],
	'xml': ['x.?ml'],
	'bootstrap': ['bootstr?ap'],
	'data science': ['data science'],
	'firebase': ['firebase'],
	'xamarin': ['xamarin'],
	'odoo': ['odoo'],
	'mean': ['mean'],
	'mern': ['mern'],
	'deep learning': ['deep learning'],
	'entity framework': ['.*entity framework.*'],
	'json': ['json'],
	'linq': ['linq'],
	'mvc': ['mvc', 'model view controller'],
	'tfs': ['tfs'],
	'wcf': ['wcf'],
	'servlet': ['servlet'],
	'prisma': ['prisma'],
	'figma': ['figma'],
	'adobe xd': ['adobe xd'],
	'less': ['less'],
	'istqb': ['istqb'],
	'numpy': ['numpy'],
	'database': ['database', 'database design'],
	'pytorch': ['pytorch'],
	'golang': ['^go$', 'golang'],
	'postgres': ['postgres'],
	'java': ['jsf', 'jsp', 'j2ee'],
	'pearl': ['pearl'],
	'assembly': ['assembly'],
	'dagger': ['dagger'],
	'scikit': ['scikit'],
	'keras': ['keras'],
	'tensorflow': ['tensor.?flow'],
	'elasticsearch': ['elastic.?search'],
	'excel': ['^excel$']
};

const prepareAssocMap = assoc => {
	const result: any = {};
	Object.keys(assoc).forEach(mapTo => {
		assoc[mapTo].forEach(mapping => {
			result[mapping] = mapTo;
		});
	});
	return result;
};

export const extractSkillsFromDescription = htmlDesc => {
	const assocMap = prepareAssocMap(skills_patterns);
	const stringDesc = removeNonAscii(parseHtml(htmlDesc)).toLowerCase().replace('-', '');
	const foundSkills: any[] = [];

	Object.keys(assocMap).forEach(word => {
		const regex = new RegExp(word, 'g');
		if (regex.test(stringDesc)) foundSkills.push(assocMap[word]);
	});
	return foundSkills;
};
